export const paths = {
    linescore: [
        {
            url: './linescore',
            path: 'linescore',
            name: 'Linescore'
        },
        {
          url: './driver',
          path: 'driver',
          name: 'Driver Analysis'
        },
        {
            url: './brands',
            path: 'brands',
            name: 'Competitors'
        },
        {
            url: './other',
            path: 'other',
            name: 'Tables'
        },
        {
            url: './ratings',
            path: 'ratings',
            name: 'Rating Sets'
        },
        {
            url: './individuals',
            path: 'individuals',
            name: 'Individuals'
        },
        {
          url: './vw',
          path: 'vw',
          name: 'Van Westendorp'
        }
        // {
        //     url: './slides',
        //     path: 'slides',
        //     name: 'Slides'
        // }
    ],
    crosstab: [
        {
            url: './other',
            path: 'other',
            name: 'Tables'
        },
        {
            url: './ratings',
            path: 'ratings',
            name: 'Rating Sets'
        },
        {
            url: './individuals',
            path: 'individuals',
            name: 'Individuals'
        }
    ],
    "type3": [
        {
            url: './linescores',
            path: 'linescores',
            name: 'Linescores'
        },
        {
            url: './brands',
            path: 'brands',
            name: 'Competitors'
        },
        {
            url: './driver',
            path: 'driver',
            name: 'Driver Analysis'
        },
        {
            url: './other',
            path: 'other',
            name: 'Tables'
        },
        {
            url: './ratings',
            path: 'ratings',
            name: 'Rating Sets'
        },
        {
            url: './individuals',
            path: 'individuals',
            name: 'Individuals'
        }
    ],
    'concept_linescore': [
        {
            url: './linescore',
            path: 'linescore',
            name: 'Linescore'
        },
        {
            url: './brands',
            path: 'brands',
            name: 'Competitors'
        },
        {
            url: './driver',
            path: 'driver',
            name: 'Driver Analysis'
        },
        {
            url: './other',
            path: 'other',
            name: 'Tables'
        },
        {
            url: './ratings',
            path: 'ratings',
            name: 'Rating Sets'
        },
        {
            url: './individuals',
            path: 'individuals',
            name: 'Individuals'
        }
    ],
    // TODO: Add this type
    scorecard: [

    ],
    'summary': [
        { url: './summary', path: 'summary', name: 'summary' }
    ]
}